import React, { useState } from 'react'

export default function App() {
	const [formData, setFormData] = useState({
		fullName: '',
		phone: '',
		city: '',
		address: '',
	})

	// حالة جديدة لمعرفة ما إذا كان الطلب قد أُرسل بنجاح لإظهار صفحة الشكر
	const [isSubmitted, setIsSubmitted] = useState(false)

	// مسار الصورة في مجلد public
	const logoURL = '/taroumante.jpg'

	const handleChange = e => {
		setFormData({ ...formData, [e.target.name]: e.target.value })
	}

	const handleSubmit = e => {
		e.preventDefault()

		// ضع رابط الـ Web app URL الصحيح بعد تعديل الصلاحيات إلى Anyone
		const googleSheetURL =
			'https://script.google.com/macros/s/AKfycbyH9KeW0AIDOP39lmFFurNqQRp5CGQfRVKcd06xmr7U5JFWrOTCGeSYUrgGSVFgCW7fhQ/exec'
		setIsSubmitted(true)
		fetch(googleSheetURL, {
			method: 'POST',
			mode: 'no-cors',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(formData),
		})
			.then(() => {
				// تحويل المستخدم إلى صفحة الشكر مباشرة عند نجاح الإرسال
			})
			.catch(error => {
				console.error('حدث خطأ أثناء إرسال الطلب:', error)
				alert('عذراً، حدث خطأ ما. يرجى المحاولة مرة أخرى.')
			})
	}

	return (
		<div
			style={{ direction: 'rtl', fontFamily: 'sans-serif' }}
			className='bg-light text-dark min-vh-100 d-flex flex-column justify-content-between'
		>
			{/* 1. الترويسة (Header) */}
			<nav className='navbar navbar-light bg-white shadow-sm sticky-top'>
				<div className='container d-flex justify-content-between align-items-center'>
					<a
						className='navbar-brand d-flex align-items-center m-0'
						href='javascript:void(0)'
					>
						<img
							src={logoURL}
							alt='TAROUMANTE BIO Logo'
							height='60'
							className='d-inline-block align-top rounded-3'
							onError={e => {
								e.target.style.display = 'none'
							}}
						/>
					</a>
					<span className='fw-bold fs-4 text-success'>Taroumante Bio</span>
				</div>
			</nav>

			{/* 2. قسم المحتوى المتمركز في الوسط */}
			<header className='py-5 bg-white border-bottom flex-grow-1 d-flex align-items-center'>
				<div className='container'>
					<div className='row justify-content-center w-100 m-0'>
						<div className='col-md-8 col-lg-6'>
							{/* شرط: إذا تم إرسال النموذج بنجاح، اعرض صفحة الشكر */}
							{isSubmitted ? (
								<div className='card shadow-lg border-0 rounded-4 bg-light text-center p-4 p-sm-5 animate__animated animate__fadeIn'>
									<div className='mb-4'>
										{/* أيقونة صح خضراء معبرة */}
										<div
											className='bg-success-subtle text-success rounded-circle d-inline-flex align-items-center justify-content-center'
											style={{ width: '80px', height: '80px' }}
										>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='45'
												height='45'
												fill='currentColor'
												className='bi bi-check-circle-fill text-success'
												viewBox='0 0 16 16'
											>
												<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z' />
											</svg>
										</div>
									</div>
									<h4 className='text-success fw-bold mb-4'>
										تم تسجيل طلبك بنجاح 🎉
									</h4>

									<div className='p-3 bg-white rounded-3 border mb-4 text-start'>
										<p className='mb-0 text-dark small'>
											يقوم فريق خدمة العملاء لدينا حالياً بمراجعة البيانات،
											وسيتم الاتصال بك هاتفياً في أقرب وقت لتأكيد العنوان وتجهيز
											طلبيتك للشحن الإرسال.
										</p>
									</div>
								</div>
							) : (
								/* وإذا لم يتم الإرسال بعد، اعرض استمارة الطلب العادية */
								<div className='card shadow-lg border-0 rounded-4 bg-light text-start'>
									<div className='card-body p-4 p-sm-5'>
										<h3 className='card-title text-center fw-bold text-dark mb-1'>
											قم بملء الاستمارة للطلب
										</h3>
										<p className='text-center text-success fw-bold small mb-4'>
											التوصيل مجاني والدفع عند الاستلام في المغرب!
										</p>

										<form onSubmit={handleSubmit}>
											{/* الاسم الكامل */}
											<div className='mb-3'>
												<label className='form-label fw-bold text-secondary small mb-1 d-block text-end'>
													الاسم الكامل *
												</label>
												<input
													type='text'
													name='fullName'
													required
													value={formData.fullName}
													onChange={handleChange}
													className='form-control text-end'
													placeholder='الاسم الكامل الخاص بك'
												/>
											</div>

											{/* رقم الهاتف */}
											<div className='mb-3'>
												<label className='form-label fw-bold text-secondary small mb-1 d-block text-end'>
													رقم الهاتف *
												</label>
												<input
													type='tel'
													name='phone'
													required
													value={formData.phone}
													onChange={handleChange}
													className='form-control text-start'
													placeholder='06XXXXXXXX'
												/>
											</div>

											{/* المدينة */}
											<div className='mb-3'>
												<label className='form-label fw-bold text-secondary small mb-1 d-block text-end'>
													المدينة *
												</label>
												<input
													type='text'
													name='city'
													required
													value={formData.city}
													onChange={handleChange}
													className='form-control text-end'
													placeholder='اكتب اسم مدينتك هنا'
												/>
											</div>

											{/* عنوان السكن */}
											<div className='mb-4'>
												<label className='form-label fw-bold text-secondary small mb-1 d-block text-end'>
													عنوان التوصيل *
												</label>
												<input
													type='text'
													name='address'
													required
													value={formData.address}
													onChange={handleChange}
													className='form-control text-end'
													placeholder='رقم المنزل، اسم الشارع أو الحي'
												/>
											</div>

											{/* زر الشراء */}
											<div className='d-grid'>
												<button
													type='submit'
													className='btn btn-danger btn-lg fw-bold py-2 fs-4 text-white shadow'
													style={{
														backgroundColor: '#e65c00',
														borderColor: '#e65c00',
													}}
												>
													تأكيد الطلب الآن
												</button>
											</div>
										</form>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</header>

			{/* 4. تذييل الصفحة */}
			<footer className='py-4 bg-dark text-white-50 text-center'>
				<div className='container'>
					<p className='mb-0'>
						جميع الحقوق محفوظة © {new Date().getFullYear()} - TAROUMANTE BIO
					</p>
				</div>
			</footer>
		</div>
	)
}
